export const animals = {
  "Domestic Animals": {
    items: [
      "Dogs",
      "Cats",
      "Fish",
      "Birds",
      "Rabbits",
      "Hamsters",
      "Guinea Pigs",
      "Ferrets",
    ],
  },
  "Farm Animals": {
    items: [
      "Cows",
      "Horses",
      "Sheep",
      "Goats",
      "Pigs",
      "Chickens",
      "Ducks",
      "Turkeys",
    ],
  },
  "Exotic Animals": {
    items: [
      "Goats",
      "Pigs",
      "Sheep",
      "Mice",
      "Lizards",
      "Geckos",
      "Iguanas",
      "Rats",
    ],
  },
} as const;
